var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Market")]),_c('ul',_vm._l((_vm.widgetsMarket),function(widget){return _c('li',{key:widget.id,on:{"click":function($event){return _vm.addWidget(widget.component)}}},[_vm._v(_vm._s(widget.name))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }